<template>
  <div class="open-class-item">
    <img v-if="type===0" class="open-class-info" src="../../assets/img/open-class@reserve.png" />
    <img v-else-if="type===1" class="open-class-info" src="../../assets/img/open-class@live.png" />
    <img v-else class="open-class-info" src="../../assets/img/open-class@replay.png" />
    <div class="open-class-detail">
      <img class="open-class-left" :src="avatar" />
      <div class="open-class-center">
        <p class="open-class-title">{{title}}</p>
        <p class="open-class-teacher">授课老师：{{name}}</p>
        <p class="open-class-time">时间：{{time}}</p>
      </div>
      <div class="open-class-right">
        <template v-if="type==0">
          <span class="open-class-status">{{num?num+"预约":""}}</span>
          <div class="open-class-button open-class-reserve" @click="onReserve">
            <span class="text">立即预约</span>
          </div>
        </template>
        <template v-else-if="type==1">
          <span class="open-class-status">{{num?num+"观看":""}}</span>
          <div class="open-class-button open-class-live" @click="onLive">
            <img class="gif" src="../../assets/img/open-class/playing.gif" />
            <span class="text">进入直播</span>
          </div>
        </template>
        <template v-else>
          <span class="open-class-status">已结束</span>
          <div class="open-class-button open-class-replay" @click="onReplay">
            <span class="text">直播回放</span>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'OpenClassItem',
    props: {
      type: Number,
      avatar: String,
      title: String,
      name: String,
      time: String,
      num: Number,
    },
    methods: {
      onReserve() {
        this.$emit('reserve');
      },

      onLive() {
        this.$emit('live');
      },

      onReplay() {
        this.$emit('replay');
      },
    },
  };
</script>

<style lang="scss" scoped>
@import "~assets/scss/mixins";

.open-class-item {
  position: relative;
  padding: 8px 10px 7px 15px;
  letter-spacing: 0.5px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0px 2px 6px #ddd;
}

.open-class-info {
  position: absolute;
  left: 6px;
  top: -8px;
  width: 45px;
  height: 14px;
}

.open-class-detail {
  display: flex;
  align-items: center;
  width: 100%;
}

.open-class-left {
  width: 60px;
  height: 60px;
  border: 1px solid #eee;
  border-radius: 50%;
}

.open-class-center {
  flex: 1;
  display: inline-flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0 15px;
  height: 50px;
  color: #333;
  line-height: 1;
  overflow: hidden;
}

.open-class-title {
  font-size: 12px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.open-class-teacher {
  font-size: 10px;
}

.open-class-time {
  font-size: 10px;
}

.open-class-right {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  height: 50px;
}

.open-class-status {
  font-size: 11px;
  color: #999;
}

.open-class-button {
  position: relative;
  padding: 0 4px;
  height: 20px;
  line-height: 20px;
  font-size: 10px;
  color: #fff;
  border-radius: 4px;
}

.open-class-reserve {
  background-color: #f5c33c;
}

.open-class-live {
  background-color: #3c59f5;
}

.open-class-replay {
  background-color: #993cf5;
}

.gif {
  position: absolute;
  left: -22px;
  top: 0px;
  width: 20px;
}
</style>
